export const REEL_DEFAULT_COVER_RATIO = 300 / 168;
export const REEL_DEFAULT_COVER_RATIO = 300 / 168;
